
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Link, Image } from '@ta-interaktiv/contentbricks'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Angesichts der Corona-Krise gibt es viele Tipps, die sich auf zahlreiche
  Studien berufen und empfehlen, die Smartphones und Tablets nicht nur
  regelmässig zu reinigen, sondern auch zu desinfizieren. Tatsächlich aber sind
  solche Empfehlungen zumindest fragwürdig, sagen Hygiene-Experten. «Handys sind
  viel weniger kontaminiert, als man das denkt», sagt etwa Mikrobiologe Markus
  Egert, der zu Hygiene im Alltag forscht. In einer 2015 veröffentlichten Studie
  fand er heraus, dass sich auf einem Quadratzentimeter Touchscreen
  durchschnittlich nur eine Bakterie findet. Viren auf Handys habe er zwar nicht
  untersucht, «aber auch da ist davon auszugehen, dass das keine Virenschleudern
  sind», sagt Egert.
    </p>
    <p>
  Er sehe aktuell keinen Bedarf, das Smartphone zu desinfizieren, sagt auch der
  Ärztliche Direktor des Deutschen Beratungszentrums für Hygiene, Ernst Tabori.
  Handys seien in der Regel ein sehr persönlicher Gegenstand und würden nicht
  weitergereicht. Das Handy sei das Spiegelbild der eigenen Sauberkeit
  beziehungsweise der eigenen Keime. Wichtiger sei daher, die Hände regelmässig
  und gründlich zu waschen, sagt Tabori.
    </p>
    <p>
  Mikrobiologe Egert hält es unabhängig von der Corona-Pandemie für sinnvoll,
  das Smartphone oder Handy hin und wieder zu reinigen. «Es reicht aber völlig
  aus, das Gerät mit einem dezent feuchten Tuch oder Brillenputztuch
  abzuwischen», sagt er. Nur wer in einem klinischen Umfeld arbeite und sein
  Gerät dorthin mitnehme, müsse sein Smartphone oder Tablet darüber hinaus
  reinigen und desinfizieren.
    </p>
    <p>
  Das iPhone – so, wie Apple es empfiehlt – mit einem mit Desinfektionsmittel
  befeuchteten Tuch abzuwischen, könne man, um das Gewissen zu beruhigen. Es sei
  aber absolut nicht nötig, sagen sowohl Tabori als auch Egert.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;